import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Button, H3, Text } from 'atoms';
import { useDispatchUi } from 'context/ui';
import { useRouter } from 'next/router';
import LargeButton from '@/components/Views/Buttons';

interface Props {
    heading: string;
    ctalink?: string;
    ctalabel: string;
    bgColor?: string;
    subhead?: string;
}

export const ConversionPanel1 = (
    {
        heading,
        subhead,
        ctalabel,
        ctalink,
        bgColor
    }: Props) => {
    const dispatch: any = useDispatchUi();
    const router = useRouter();
    return (
        <div id='panel'>
            <Fade>
                <div id='panel-content'>
                    <H3 style={{ color: '#121651' }}>{heading}</H3>
                    <Text mt={4} mb={5}>
                        {subhead}
                    </Text>
                    <LargeButton
                        className='blue-button mx-auto'
                        innerClassName='px-10'
                        text={ctalabel}
                        href={ctalink}
                        newTab={true}
                    />
                    <img
                        src='/assets/graphics/esser-share.png'
                        style={{
                            maxWidth: '560px',
                            margin: '0 auto',
                            width: '90%',
                            marginTop: '40px'
                        }}
                        alt='Share'
                    />
                </div>
            </Fade>
            <style jsx>
                {`
                    #panel {
                        background-color: ${bgColor || '#f9f9f9'};
                        padding: 48px 60px;
                    }

                    #panel-content {
                        text-align: center;
                        max-width: 800px;
                        margin: 0 auto;

                        #heading {
                            color: #121651;
                        }
                    }

                    @media (max-width: 992px) {
                        #panel {
                            padding: 48px 40px;
                        }
                    }

                    @media (max-width: 480px) {
                        #panel {
                            padding: 48px 20px;
                        }
                    }
                `}
            </style>
        </div>
    );
};
